// extracted by mini-css-extract-plugin
export default {"uploadForm":"Insights_uploadForm__UAbYb","deleteButton":"Insights_deleteButton__mbKbl"};